export { useQuery } from './useQuery';
//# sourceMappingURL=index.js.map